import React, { useEffect, useRef, forwardRef } from "react";
import { RiSearchLine } from "react-icons/ri";

const SearchInputField = forwardRef(
  (
    {
      id,
      placeholder = "Search...",
      value,
      onChange,
      shortcut = "Ctrl K",
      disabled = false,
      state,
      error,
      className = "",
      ...rest
    },
    ref
  ) => {
    const innerRef = useRef(null);
    const inputRef = ref || innerRef; // always safe

    // Add keyboard shortcut listener
    useEffect(() => {
      const handleKeyDown = (e) => {
        if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "k") {
          e.preventDefault();
          inputRef.current?.focus();
        }
      };

      window.addEventListener("keydown", handleKeyDown);
      return () => window.removeEventListener("keydown", handleKeyDown);
    }, [inputRef]);

    const base =
      "mt-0.5 flex h-9 w-full items-center justify-center rounded-md border bg-white/0 p-3 text-sm outline-none";

    const stateClasses = disabled
      ? "!border-none !bg-gray-100 dark:!bg-white/5 dark:placeholder:!text-[rgba(255,255,255,0.15)]"
      : state === "success"
      ? "border-green-500 text-green-600 placeholder:text-green-500 dark:!border-green-400 dark:!text-green-400 dark:placeholder:!text-green-400"
      : "border-gray-200 dark:!border-white/10 dark:text-white";

    return (
      <div>
        <div className={`${base} ${stateClasses} ${className}`}>
          <RiSearchLine className="mr-2 hidden h-5 w-5 text-gray-400 dark:text-gray-500 lg:flex" />

          <input
            ref={inputRef}
            id={id}
            type="text"
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            disabled={disabled}
            className="mt-0.5 flex h-9 w-full items-center justify-center  bg-white/0 py-3 text-sm outline-none dark:text-white"
            {...rest}
          />

          {shortcut && (
            <span className="ml-2 hidden items-center gap-1  rounded text-gray-500 dark:text-gray-400 lg:flex    ">
              {shortcut.split(" ").map((key, idx) => (
                <kbd
                  key={idx}
                  className="rounded  bg-gray-100 px-1 py-0.5 text-xs font-medium shadow-sm dark:bg-gray-800 dark:text-gray-200"
                >
                  {key}
                </kbd>
              ))}
            </span>
          )}
        </div>
      </div>
    );
  }
);

SearchInputField.displayName = "SearchInputField";
export default SearchInputField;
